var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { Card } from "../../components/modules/Card";
import { Text } from "../../components/elements/Text";
import CheckIconImage from "../../../images/icone-check.svg";
import { Container, Wrapper, ContentContainer, InfoContainer, CheckImage, } from "./styles";
import ResendLink from "../../components/modules/ResendLink";
export function ForgotPasswordSuccess() {
    var location = useLocation();
    var onResendEmail = useAuth().onResendEmail;
    var state = location.state;
    if (state === null) {
        return _jsx(Navigate, { replace: true, to: "/senha/email" });
    }
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsx(ContentContainer, { children: _jsxs(InfoContainer, { children: [_jsx(CheckImage, { src: CheckIconImage, alt: "check" }), _jsx(Box, __assign({ marginBottom: "1rem" }, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "Enviamos uma confirma\u00E7\u00E3o para" })) })), _jsx(Box, __assign({ marginBottom: "2rem" }, { children: _jsx(Text, __assign({ textStyle: "body2", color: "fakeBlack" }, { children: state.email_masked })) })), _jsx(Box, __assign({ marginBottom: "3rem" }, { children: _jsx(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: "Acesse o link que enviamos para definir uma nova senha." })) })), _jsx(ResendLink, { href: "#resend", onClick: function (evt) {
                                    onResendEmail(state.login);
                                    evt.preventDefault();
                                } })] }) }) }) }) }));
}
